import { combineReducers } from 'redux';
import violation, * as fromViolation from './violationReducer';

export default combineReducers({
  violation,
});

export const getViolation = (state) => fromViolation.getViolation(state.violation);
